import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WelcomeSection from './components/WelcomeSection';
import WhyChooseUs from './components/WhyChooseUs';
import ImpactStats from './components/ImpactStats';
import ServicesPreview from './components/ServicesPreview';
import LeadershipPreview from './components/LeadershipPreview';
import TestimonialsSection from './components/TestimonialsSection';
import GalleryPreview from './components/GalleryPreview';
import CTASection from './components/CTASection';
import NewsPreview from './components/NewsPreview';
import BooksPreview from './components/BooksPreview';

export default function Home() {
  useEffect(() => {
    document.title = 'TGMCI - The Great Multitude Church International | Edea, Cameroon';
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add('visible');
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );
    const elements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <WelcomeSection />
        <WhyChooseUs />
        <ImpactStats />
        <ServicesPreview />
        <LeadershipPreview />
        <BooksPreview />
        <GalleryPreview />
        <TestimonialsSection />
        <NewsPreview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}